import api from '@pray/shared/utils/api';

import type { RecurringInstance, RecurringInstanceListResponse } from './types';

// Paginated envelope from `sendPaginatedListResponseWithTotal` (no counts).
type InstancesEnvelope = {
  responded_at: string;
  object: 'list';
  last_item_identifier: string | number | null;
  data_count: number;
  total: number;
  limit: number;
  offset: number;
  data: RecurringInstance[];
};

// GET …/campaigns/recurring/:id/instances — the spawned EmailCampaigns,
// newest first. Each carries `scheduled_at` + `status` + `recipient_count`.
export async function getRecurringCampaignInstances({
  artistId,
  recurringCampaignId,
  offset,
  limit,
}: {
  artistId: string;
  recurringCampaignId: string;
  offset?: number;
  limit?: number;
}): Promise<RecurringInstanceListResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const params: Record<string, string | number> = {};
  if (offset !== undefined) params.offset = offset;
  if (limit !== undefined) params.limit = limit;

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}/instances`;
  const response = await api.executeGetRequest<InstancesEnvelope>(url, params);
  const envelope = response.data;
  return {
    data: envelope.data,
    data_count: envelope.data_count,
    total: envelope.total,
    limit: envelope.limit,
    offset: envelope.offset,
  };
}
